import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycSetUpASupplementalNeedsTrustForGovernmentBenefitsPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-set-up-a-supplemental-needs-trust-for-government-benefits/']} />;
}
